/**
 * Display helpers for user-facing text.
 */

/**
 * Title-case a person's name, handling all-caps inputs.
 *   "Kurt FRANCOIS"   → "Kurt Francois"
 *   "JEAN-PIERRE"     → "Jean-Pierre"
 *   "o'brien"         → "O'Brien"
 *   "Already Fine"    → "Already Fine"
 *
 * Splits on space/hyphen/apostrophe, capitalises the first letter of each
 * fragment and lowercases the rest. Returns the input unchanged if falsy.
 */
export const toTitleCase = (s) => {
  if (!s || typeof s !== 'string') return s || '';
  return s
    .toLowerCase()
    .replace(/(^|[\s\-'])(\p{L})/gu, (_, sep, ch) => sep + ch.toUpperCase());
};

/**
 * Compact number formatting for view counts.
 *   999        → "999"
 *   1500       → "1.5k"
 *   125000     → "125k"
 *   1240000    → "1.2M"
 */
export const formatCompactNumber = (n) => {
  const num = Number(n) || 0;
  if (num < 1000) return String(num);
  if (num < 1_000_000) {
    const v = num / 1000;
    return `${v < 10 ? v.toFixed(1).replace(/\.0$/, '') : Math.round(v)}k`;
  }
  const v = num / 1_000_000;
  return `${v < 10 ? v.toFixed(1).replace(/\.0$/, '') : Math.round(v)}M`;
};
